import { useEerieBackdrop } from "@/lib/eerie";
import { MatchKeyHost } from "@/components/MatchKey/MatchKeyShell";
import { PENTE_CFG } from "@/components/MatchKey/cfgs";

export default function PenteHostPage() {
  useEerieBackdrop("pente");
  return <MatchKeyHost cfg={PENTE_CFG} />;
}
